var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHdTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 1851,
    viewBox: "4.635 7.877 784.352 580.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.404 361.639L4.635 588.616h712.001c40.071 0 72.351-32.28 72.351-72.352v-82.275c0-40.07-32.28-72.351-72.351-72.351H54.404z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M312.44 555.677h-38.154l32.343-131.011h-54.325l6.443-26.288h145.919l-6.443 26.288h-53.566L312.44 555.677zm170.176 0h-40.681l-23.363-157.299h38.027l13.636 118.993 76.687-118.993h37.774l-102.08 157.299z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.986 14.566a424129.638 424129.638 0 0 0-70.332 303.856H176.28c9.582-41.296 19.305-78.602 28.764-119.922h90.949c-9.244 39.975-18.542 79.94-27.753 119.922h113.627C405.808 215.1 429.713 111.771 453.451 8.409H340.146c-8.295 35.672-16.729 71.317-25.11 106.972h-90.948c7.948-34.332 15.87-72.632 23.777-106.972H134.399l-.914 3.982-.499 2.175zM628.243 8.153c-39.364.613-78.866.077-118.282.257a616007.146 616007.146 0 0 0-66.136 310.527c86.73-.556 185.017 7.16 262.455-26.038 83.155-49.544 109.82-160.422 51.215-239.34C727.37 19.03 674.844 5.739 628.243 8.153zm5.051 78.113c26.311-2.15 50.942 17.077 48.908 40.019 6.534 43.842-11.724 98.883-63.919 112.23-16.593 2.864-34.727 2.502-52.244 2.309a8422956.64 8422956.64 0 0 1 32.662-153.788c11.585.016 23.166.311 34.593-.77z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdTv);
export default __webpack_public_path__ + "static/media/hd-tv.3e80c6cfd1637af73aa6ae5a687cc012.svg";
export { ForwardRef as ReactComponent };